import { render, staticRenderFns } from "./TemplateCategories.vue?vue&type=template&id=5873448b&scoped=true&"
import script from "./TemplateCategories.vue?vue&type=script&lang=js&"
export * from "./TemplateCategories.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCategories.vue?vue&type=style&index=0&id=5873448b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5873448b",
  null
  
)

export default component.exports